<script setup>
import { ref } from 'vue'
import {__, mareike_check_filesize} from '../../../assets/javascripts/library.js'
import InfoIcon from '../../../assets/components/InfoIcon.vue'
import RefundData from "./refund-data.vue";
import AmountInput from "../../../assets/components/AmountInput.vue";

const data = defineProps({
  user_id: Number,
  eventId: Number,
  dynamicText: Object,
  user_name: String,
  user_email: String,
  user_iban: String,
  user_account_owner: String,
})

const invoiceType = ref(null);
const amount = ref(null);
const otherText = ref('');
const receipt = ref(null)
const finalStep = ref(false)

function handleFileChange(event) {
  if (mareike_check_filesize('receipt')) {
    receipt.value = event.target.files[0]
    finalStep.value = true
  } else {
    event.target.value = null
  }
}

</script>

<template>
  <fieldset>
    <legend><span style="font-weight: bolder;">{{__( 'What did you pay for?', 'mareike' )}}</span></legend>

    <input type="radio" name="kostengruppe" value="Accommodation" id="kosten_unterkunft" v-model="invoiceType">
    <label for="kosten_unterkunft">{{__( 'Accommodation', 'mareike' )}}</label>
    <InfoIcon :text="data.dynamicText.INFO_ACCOMMODATION" /><br />

    <input type="radio" name="kostengruppe" value="Catering" id="kosten_verpflegung" v-model="invoiceType">
    <label for="kosten_verpflegung">{{__( 'Catering', 'mareike' ) }}</label>
    <InfoIcon :text="data.dynamicText.INFO_CATERING" /><br />

    <input type="radio" name="kostengruppe" value="Program" id="kosten_programm" v-model="invoiceType">
    <label for="kosten_programm">{{__( 'Program', 'mareike' )}}</label>
    <InfoIcon :text="data.dynamicText.INFO_PROGRAM" /><br />

    <input type="radio" name="kostengruppe" value="Other" id="kosten_sonstiges" v-model="invoiceType">
    <label for="kosten_sonstiges">
      <input
          type="text"
          class="mareike-text"
          name="kostengruppe_sonstiges"
          :placeholder="__( 'Other', 'mareike' )"
          for="kosten_sonstiges"
          v-model="otherText"
          @focus="invoiceType = 'Other'"
      />
      <InfoIcon :text="data.dynamicText.INFO_OTHER" /><br />
    </label>

  </fieldset><br /><br />

  <fieldset>
    <legend><span style="font-weight: bolder;">{{ __( 'How much is the amount?', 'mareike' ) }}</span></legend>
    <AmountInput v-model="amount" class="mareike-text" id="amount" name="amount"  /> Euro
    <info-icon></info-icon>
  </fieldset><br />

    <button
        v-if="amount !== null && invoiceType !== null"
        class="mareike-button"
        onclick="document.getElementById('receipt').click();"
        type="button"
    >
      {{__( 'Select receipt and continue', 'mareike' )}}
    </button>
    <input accept="application/pdf" type="file" id="receipt" name="receipt"     @change="handleFileChange"
           style="display: none"/>

  <RefundData
      v-if="finalStep"
      :event-id="data.eventId"
      :invoice-type="invoiceType"
      :amount="amount"
      :other-text="otherText"
      :receipt="receipt"
      :user_name="data.user_name"
      :user_email="data.user_email"
      :user_iban="data.user_iban"
      :dynamicText="data.dynamicText"
      :user_account_owner="data.user_account_owner"
      :user_id="data.user_id"
  />


</template>

<style scoped>

</style>




